<template>
  <component :is='componentName' v-model='value' v-bind="{...$props}"></component>
</template>
<script>
  import {textAreaProps} from './index'
  import Edit from './components/edit-text-area.vue'
  import Read from './components/read-text-area.vue'

  export default {
    name: 'text-area',
    model: {
      prop: 'value',
      event: 'change'
    },
    props: textAreaProps,
    components: {Edit, Read},
    computed: {
      componentName () {
        if (this.isPureText) return 'Read'
        return 'Edit'
      }
    },
    watch: {
      value (val) {
        this.$emit('change', val)
      }
    }
  }
</script>

<style scoped lang="scss"></style>
